module.exports = {
  zoomBox: require('./zoom-box'),
  definiteIntegral: require('./definite-integral')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/function-plot/lib/plugins/index.js
// module id = xNEe
// module chunks = 0